import {useLazyQuery, gql} from "@apollo/client";

export const  BLOGS_COUNT = gql`
query BlogsCountFa { 
    blogsCount {
      blogCount
    }
  }
  `;

